import { render, staticRenderFns } from "./StatisMapAdmin.vue?vue&type=template&id=454b0abb&scoped=true&"
import script from "./StatisMapAdmin.vue?vue&type=script&lang=js&"
export * from "./StatisMapAdmin.vue?vue&type=script&lang=js&"
import style0 from "./StatisMapAdmin.vue?vue&type=style&index=0&id=454b0abb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454b0abb",
  null
  
)

export default component.exports